<template>
  <div class="b-field-title">{{ title }}</div>
  <div :class="[{disabled: disabled, visible}]" v-click-out="clickOutsideHandler" class="input-container">
    <div class="select-label" :class="[hasError ? 'input-error' : '']" @click="searchToggle()">
      {{ value || placeholder }}
      <font-awesome-icon icon="angle-down" class="small"/>
    </div>

    <transition-group name="fly-fast">
      <div v-if="visible" class="select-list">
        <div class="select-input-container">
          <input
              :ref="endpoint"
              v-model="searchQuery"
              placeholder="Поиск"
              type="text"
              class="select-input"
              autocomplete="false"
              @input="inputHandler($event.target.value)"
          >
        </div>

        <div :class="{space: notFound || loading}" class="add-info-b">
          <div v-if="notFound && !loading" class="text-muted not-found-container">
            Ничего не найдено
          </div>

          <transition name="fade">
            <div v-if="loading" class="preloader"></div>
          </transition>

          <div v-for="item in items" :key="item.id" class="select-list-item" @click="select(item[endpoint])">
            <div class="address-item">
              <slot :item="item"></slot>
            </div>
          </div>
        </div>
      </div>
    </transition-group>
  </div>
</template>

<script>
import {search} from '@api/search';
import {mapGetters, mapMutations} from 'vuex';

export default {
  name: 'Selection',
  props: {
    endpoint: {
      type: String,
      default: () => '',
    },
    items: {
      type: Array,
      default: () => [],
    },
    value: {
      type: String,
      default: () => '',
    },
    placeholder: {
      type: String,
      default: () => '',
    },
    title: {
      type: String,
      default: () => '',
    },
    disabled: {
      type: Boolean,
      default: () => false,
    },
    formErrors: {
      type: Object,
      required: true,
    },
  },
  emits: ['select'],
  data() {
    return {
      loading: false,
      visible: false,
      searchTimer: null,
      searchTimeout: 300,
      searchQuery: null,
      notFound: false,
    };
  },
  computed: {
    ...mapGetters([
      'fieldDeps',
    ]),
    hasError() {
      return this.formErrors[this.endpoint].$error;
    },
  },
  methods: {
    ...mapMutations([
      'setSearchItems'
    ]),
    searchToggle() {
      if (this.disabled) {
        return;
      }

      this.visible = !this.visible;

      this.$nextTick(() => {
        if (this.visible) {
          this.$refs[this.endpoint].focus();
        }
      });
    },
    clickOutsideHandler() {
      if (this.visible) {
        this.visible = false;
      }
    },
    search(text) {
      this.loading = true;
      const params = {s: text};
      const {parent_id} = this.fieldDeps[this.endpoint];

      if (parent_id) {
        Object.assign(params, {pid: parent_id});
      }

      search(this.endpoint, params).then(items => {
        this.setSearchItems({
          type: this.endpoint,
          items
        });

        this.loading = false;

        this.notFound = !items.length;
      });
    },
    inputHandler(text) {
      clearTimeout(this.searchTimer);
      this.searchTimer = setTimeout(() => {
        this.search(text);
      }, this.searchTimeout);
    },
    select(item) {
      this.$emit('select', item);
      this.visible = false;
    },
  },
};
</script>

<style scoped>
.address-item {
  text-overflow: ellipsis;
  white-space: nowrap;
  overflow: hidden;
}

.select-label {
  padding: 8px 12px;
  border: 1px solid #ccc;
  font-size: 15px;
  width: 100%;
  border-radius: 3px;
  background-color: #fff;
  user-select: none;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-top: -1px;
}

.select-list {
  border: 1px solid #ccc;
  font-size: 15px;
  width: 100%;
  border-radius: 3px;
  background-color: #fff;
  position: absolute;
  top: 100%;
  left: 0;
  z-index: 9;
  margin-top: -1px;
  overflow: hidden;
}

.visible .select-label {
  border-radius: 3px 3px 0 0;
}

.visible .select-list {
  border-radius: 0 0 3px 3px;
  box-shadow: 0 4px 16px -8px #0009;
}

.select-list-item {
  width: 100%;
  padding: 8px 12px;
  user-select: none;
  cursor: pointer;
}

.select-list-item:hover {
  background-color: #f5f5f5;
}

.input-container {
  position: relative;
}

.input-container.disabled {
  opacity: .5;
}

.select-input-container {
  padding: 12px 12px 0;
}

.select-input {
  width: 100%;
  border-radius: 3px;
  font-size: 15px;
  padding: 5px 12px;
  border: 1px solid #ccc;
}

.add-info-b {
  position: relative;
  width: 100%;
  display: flex;
  flex-direction: column;
  align-items: self-start;
  justify-content: center;
  padding-top: 12px;
  user-select: none;
}

.add-info-b.space {
  min-height: 47.5px;
}

.not-found-container {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 100%;
  position: absolute;
  top: 0;
  height: 100%;
}
</style>
